import { FormFieldBase, FormFieldType } from "src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import { pdaRegistryConst } from "../consultazione/constants/registry-const";

export const roleSearchQuestions: FormFieldBase[] = [
    {
        controlType: FormFieldType[FormFieldType.DROPDOWN],
        key: "registry",
        label: "Registro",
        placeholder: "Selezionare il registro",
        chips: false,
        disabled: false,
        options: pdaRegistryConst.filter(reg => reg.type != "SIGP" && reg.type != "CASSCI"),
        required: true,
        size: "col-sm-3"
    },
    // {
    //     controlType: FormFieldType[FormFieldType.DROPDOWN],
    //     key: "role",
    //     label: "Ruolo",
    //     placeholder: "Selezionare il ruolo",
    //     chips: false,
    //     disabled: false,
    //     options: roles,
    //     required: true,
    //     size: "col-sm-3"
    // },
    {
        controlType: FormFieldType[FormFieldType.SEARCHABLE_DROPDOWN],
        key: "officeCode",
        label: "Autorità giudiziaria - Sede",
        placeholder: "Selezionare l'autorità giudiziaria",
        chips: false,
        disabled: false,
        options: null,
        required: true,
        size: "col-sm-3"
    },
    // {
    //     controlType: FormFieldType[FormFieldType.DROPDOWN],
    //     key: "cfDelegante",
    //     label: "Delegante",
    //     placeholder: "Selezionare il delegante",
    //     chips: false,
    //     disabled: false,
    //     options: null,
    //     required: false,
    //     size: "col-sm-3"
    // },
    {
        controlType: FormFieldType[FormFieldType.TEXT],
        key: "numeroRuolo",
        label: "Numero ruolo",
        placeholder: "Inserire numero ruolo",
        chips: false,
        disabled: false,
        required: true,
        size: "col-sm-3"
    },
    {
        controlType: FormFieldType[FormFieldType.TEXT],
        key: "annoRuolo",
        label: "Anno ruolo",
        placeholder: "Inserire anno ruolo",
        chips: false,
        disabled: false,
        required: true,
        size: "col-sm-3"
    },
];

export const dateSearchQuestions: FormFieldBase[] = [
    {
        controlType: FormFieldType[FormFieldType.DROPDOWN],
        key: "registry",
        label: "Registro",
        placeholder: "Selezionare il registro",
        chips: false,
        disabled: true,
        options: pdaRegistryConst.filter(reg => reg.value == "CC"),
        required: true,
        value: "CC",
        size: "col-sm-4"
    },
    // {
    //     controlType: FormFieldType[FormFieldType.DROPDOWN],
    //     key: "role",
    //     label: "Ruolo",
    //     placeholder: "Selezionare il ruolo",
    //     chips: false,
    //     disabled: false,
    //     options: roles,
    //     required: true,
    //     size: "col-sm-3"
    // },
    {
        controlType: FormFieldType[FormFieldType.SEARCHABLE_DROPDOWN],
        key: "officeCode",
        label: "Autorità giudiziaria - Sede",
        placeholder: "Selezionare l'autorità giudiziaria",
        chips: false,
        disabled: false,
        options: null,
        required: true,
        size: "col-sm-4"
    },
    // {
    //     controlType: FormFieldType[FormFieldType.DROPDOWN],
    //     key: "cfDelegante",
    //     label: "Delegante",
    //     placeholder: "Selezionare il delegante",
    //     chips: false,
    //     disabled: false,
    //     options: null,
    //     required: false,
    //     size: "col-sm-3"
    // },
    {
        controlType: FormFieldType[FormFieldType.TEXT],
        key: "giudice",
        label: "Giudice",
        placeholder: "Inserire giudice",
        chips: false,
        disabled: false,
        required: true,
        size: "col-sm-4"
    },
    {
        controlType: FormFieldType[FormFieldType.DATE],
        key: "dataCitazione",
        label: "Data citazione",
        placeholder: "Inserire data citazione",
        chips: false,
        disabled: false,
        size: "col-sm-6"
    },
    {
        controlType: FormFieldType[FormFieldType.DATE],
        key: "dataPrimaUdienza",
        label: "Data prima udienza",
        placeholder: "Inserire data prima udienza",
        chips: false,
        disabled: false,
        size: "col-sm-6"
    }
];